// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__32TUZ","gallery":"styles_gallery__eaigu"};